<template> 
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2 v-if="modelo">Usuários - {{modelo.nome}}</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5 row"> 
                    <div class="col-12 col-sm-12">  
                        <CardRh :processando="processando"  v-if="modelo" :key="identificador">  
                            <KDataTable :config="config" :pesquisar="false"  :reload="reloadDatatable" @tableatualizada="tableatualizada( $event )">  
                                <th pesquisavel>CPF</th> 
						        <th pesquisavel>Cargo</th> 
						        <th pesquisavel>Nome</th>
                                <th class="text-center">Ações</th> 
                                <template v-slot:filtros>  
                                    <div class="row">  
                                        <input type="text" data-kt-docs-table-filter="perfilId" v-model="perfilId" hidden/>
                                    </div>
                                </template> 
                            </KDataTable>   
                        </CardRh> 
                    </div>   
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts"> 
	 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";   
    import UsuarioService from   "@/service/v1/seguranca/UsuarioService"
	import $ from "jquery"   
 
    @Options({
        name: "Curso",
        components: {  CardRh , KDataTable   },   
    }) 
    export default class Curso extends Vue {
         
        @Prop( ) readonly modelo!: any 
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly service!: any
        @Prop( ) readonly perfis!: any 
 
        public reloadDatatable = false ;
        public processando = false;  
        public perfilId : any = null;  
        
        public config;  
        public identificador = 1 ;  
        public campos: Array<any> = [ ];
        public formulario: any  = { } ;   
        public usuarioService = new UsuarioService(); 
 
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
         
        created(){
            this.config = {  ajax: {} , columns: [] , columnDefs: [] };   
            
            this.config.ajax = { 
                url: this.usuarioService.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "perfilId": () => (document.querySelector('[data-kt-docs-table-filter="perfilId"]')! as HTMLInputElement).value , 
                    }
                    return dados; 
                } 
            };  

            this.config.columns = [ 
                { data: 'id', name: 'id'  }, 
                { data: 'cargo', name: 'cargo' }, 
                { data: 'nome', name: 'nome' }, 
                { data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center'}   
            ];  
            this.config.columnDefs = [ 
                {
                    targets: 3 ,
                    render: ( row, type, val, meta ) => {    
                        let texto = '' ;
                        for (var key in val) {  texto = texto + ' data-' + key + '="'+ val[key] +'"'  }  
                        return  '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + texto + ' > Excluir </button>'  ; 
                    }, 
                }
            ]; 
        }
  
         
        @Watch('modelo')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
            if(this.modelo){ 
                this.perfilId = this.modelo.id; 
            }  
		}

         


        public tableatualizada( event ) { 
            $('[btn-excluir]').click(  (btn) => {   
                const perfil =   $(btn.currentTarget).data('id');   
                this.removerPerfil( perfil ); 
            });  
        }  

        
        protected removerPerfil(   user  ) {  
            let dados = {
                "perfil" : this.modelo.id.toString(),
                "id" : user.toString(),
            };
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                        this.usuarioService.removerPerfil( dados )
                        .then(response => {     
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );  
        }  


    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }
</style>